"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hydrogen_react_1 = require("@shopify/hydrogen-react");
var ShopContext_1 = require("./ShopContext");
var hooks_1 = require("preact/hooks");
var color_1 = require("../common/color");
var UpsellModalV2_1 = require("../common/UpsellModalV2");
var CtaButton_1 = require("../common/Btn/CtaButton");
var ShopUpsell = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var upsell = _a.upsell, handleAddToCart = _a.handleAddToCart;
    var colors = (0, hooks_1.useContext)(ShopContext_1.default).colors;
    var _h = (0, hooks_1.useState)(false), open = _h[0], setOpen = _h[1];
    var handleClickLearn = function () { return setOpen(true); };
    // Get upsell modal data
    var upsellModalData = ((_b = upsell.upsellModalData) === null || _b === void 0 ? void 0 : _b.reference.field.value) &&
        JSON.parse((_c = upsell.upsellModalData) === null || _c === void 0 ? void 0 : _c.reference.field.value);
    // Define price data
    var price = (_d = upsell.variants) === null || _d === void 0 ? void 0 : _d.nodes[0].price;
    var compareAtPrice = (_e = upsell.variants) === null || _e === void 0 ? void 0 : _e.nodes[0].compareAtPrice;
    var upsellTitle = ((_f = upsell.altTitle) === null || _f === void 0 ? void 0 : _f.value) || upsell.title.replace('|', '');
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("div", { class: "shop-v2__upsell", style: { border: "1px solid ".concat((0, color_1.toHex)(colors.selectionsBorder)) } },
            (0, preact_1.h)("div", { class: "shop-v2__upsell-info-container" },
                (0, preact_1.h)("img", { class: "shop-v2__upsell-image", src: (_g = upsell.images) === null || _g === void 0 ? void 0 : _g.nodes[0].url }),
                (0, preact_1.h)("div", { class: "shop-v2__upsell-item" },
                    (0, preact_1.h)("div", { class: "shop-v2__upsell-info" },
                        (0, preact_1.h)("p", { class: "shop-v2__upsell-title" }, upsellTitle),
                        (0, preact_1.h)("div", { class: "shop-v2__upsell-price", style: { color: "".concat((0, color_1.toHex)(colors.upsell.bgColor)) } },
                            compareAtPrice && ((0, preact_1.h)("span", { class: "shop-v2__upsell-price shop-v2__upsell-price-compare", style: { textDecorationColor: "".concat((0, color_1.toHex)(colors.upsell.bgColor)) } }, (0, hydrogen_react_1.useMoney)(compareAtPrice).localizedString)),
                            ' ',
                            (0, hydrogen_react_1.useMoney)(price).localizedString),
                        upsellModalData && ((0, preact_1.h)("button", { class: "shop-v2__upsell-learn", onClick: handleClickLearn },
                            (0, preact_1.h)("span", { class: "shop-v2__upsell-learn shop-v2__upsell-learn--underline" }, "Learn More"),
                            ' ',
                            "\u2192"))))),
            (0, preact_1.h)(CtaButton_1.default, { text: "ADD", textColor: "white", backgroundColor: {
                    to: 'Left',
                    startColor: colors.ctaBgColor || 'white',
                    endColor: colors.ctaBgColor || 'white',
                }, hoverColor: "white", handleClick: function () { return handleAddToCart(upsell); }, size: "small" })),
        upsellModalData && ((0, preact_1.h)(UpsellModalV2_1.default, { open: open, setOpen: setOpen, price: price, upsellModalData: upsellModalData, handleAddToCart: function () { return handleAddToCart(upsell); } }))));
};
exports.default = ShopUpsell;
